import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, map, Observable, of, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private resources: { [lang: string]: { [resource: string]: { [key: string]: string } } } = {
    'de': {},
    'fr': {},
    'en': {},
  };

  translations$ = new BehaviorSubject(this.resources[this.getLanguage()]);

  constructor(private http: HttpClient, private route: ActivatedRoute) { }

  getLanguage(): string {
    let lang = this.route.snapshot.params['lang'];
    if (!lang) {
      if (window.location.href.toLowerCase().includes('/de/')) {
        lang = 'de';
      }
      if (window.location.href.toLowerCase().includes('/fr/')) {
        lang = 'fr';
      }
      if (window.location.href.toLowerCase().includes('/en/')) {
        lang = 'en';
      }
    }
    if (!lang) {
      lang = 'de';
    }
    return lang;
  }

  fetchResources(resourceFiles: string[]): void {
    const filteredFiles = resourceFiles?.filter(file => !this.resources?.[this.getLanguage()][file]);
    if (!filteredFiles?.length) {
      return;
    }

    const params = new HttpParams({
      fromObject: {
        'resources': filteredFiles,
        'url': window.location.href
      }
    });

    const language = this.getLanguage();
    this.http.get<{ [resourceKey: string]: { [key: string]: string } }>(`${language}/Language/Fetch`, { params }).pipe(
      take(1),
      map((result: { [resourceKey: string]: { [key: string]: string } }) => {
        Object.keys(result).forEach(key => {
          if (!this.resources[language][key]) {
            this.resources[language][key] = { ...result[key] };
          }
        })
      })
    ).subscribe(() => {
      this.translations$.next(this.resources[language]);
    });
  }

  resolveResources(resourceFiles: string[]): Observable<void> {
    const filteredFiles = resourceFiles?.filter(file => !this.resources?.[this.getLanguage()][file]);
    if (!filteredFiles?.length) {
      return of();
    }

    const params = new HttpParams({
      fromObject: {
        'resources': filteredFiles,
        'url': window.location.href
      }
    });

    const language = this.getLanguage();
    return this.http.get<{ [resourceKey: string]: { [key: string]: string } }>(`${language}/Language/Fetch`, { params }).pipe(
      take(1),
      map((result: { [resourceKey: string]: { [key: string]: string } }) => {
        Object.keys(result).forEach(key => {
          if (!this.resources[language][key]) {
            this.resources[language][key] = { ...result[key] };
          }
        })
        this.translations$.next(this.resources[language]);
      })
    );
  }
}
